import { Stack } from "@mui/material";
import CardComponent from "../components/atoms/CardComponent";
import Input from "../components/atoms/input";
import ButtonTranslation from "../Traduccion_ES_EN/ButtonTraslation";
import fondo from "../assets/bg-chat.png";

function LoginComponent() {
  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{
        minHeight: "100vh",
        backgroundImage: `url(${fondo})`,
        backgroundRepeat: "repeat", 
        backgroundSize: { xs: "40% auto", sm: "25% auto", md: "18% auto" }, 
        backgroundPosition: "top left",
        px: { xs: 2, sm: 3 },
      }}
    >
      <Stack
        sx={{
          position: "absolute",
          top: "1rem",
          right: "1rem",
        }}
      >
        <ButtonTranslation />
      </Stack>

      <Stack sx={{ width: "100%", maxWidth: 500 }}>
          <Input />
      </Stack>
    </Stack>
  );
}

export default LoginComponent;
